import {FlowStatePresentation} from "@nolimitcity/slot-game/bin/flowcontrol/FlowStatePresentation";
import {FlowStateController} from "@nolimitcity/slot-game/bin/flowcontrol/FlowStateController";
import {SimplePresentation, SimplePresentationRunner} from "../../core/winpresentation/SimplePresentationRunner";
import {DropOutPresentation} from "../presentations/avalanche/DropOutPresentation";
import {HTHAvalancheReelModel} from "../reels/HTHAvalancheReelModel";
import {HTH} from "../HTH";
import {HTHWinConfig} from "../configs/HTHWinConfig";
import {HTHGameConfig} from "../HTHGameConfig";

export class HTHNormalBetPresentation implements FlowStatePresentation {

    constructor() {
    }

    public start(flowStateController: FlowStateController) {
        HTH.reelArea.allReels.forEach((reel: HTHAvalancheReelModel) => {
            reel.reelView.setInteractiveSymbols(false);
        });
        HTHGameConfig.bigWinLevelPlayed=[false,false,false,false,false];
        HTHGameConfig.isBigWinLevel5Played=false;
        HTHGameConfig.lastBigWinPlayedAmount=0;
        HTH.miniPayTable.onNewBet();
        const presentations: SimplePresentation[] = [];
        presentations.push(new DropOutPresentation());

        SimplePresentationRunner.run(presentations, () => flowStateController.finish(), (callback?: Function) => flowStateController.setSkipCallback(callback));
    }
}